<abcis-table *ngIf="hasConfigured" [configuration]="tableConfig">
  <button
    pButton
    type="button"
    icon="pi pi-refresh"
    class="p-button-outlined p-button-sm"
    (click)="refreshHistory()"
    label="Refresh History"
  ></button>
</abcis-table>
